<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<style lang="scss">
  @import "~@/scss/main.scss";
</style>

<script>
import clientConfig from '/src/config/client.js';

export default {
	name: 'App',
	data () {
    return {
      clientConfig
    };
  },
	components: {},
	methods: {
    setTitle () {
      if (typeof this.clientConfig.content === 'object' && typeof this.clientConfig.content.title === 'string') {
        document.title = this.clientConfig.content.title
      }
    },
  },
	mounted() {
		this.$store.commit("setDefaultAssumptions");
		this.$store.commit("setDefaultData");

		if(clientConfig.analytics.customanalytics) {
			let customScript = document.createElement('script');
			customScript.setAttribute('src', clientConfig.analytics.customanalytics.customScriptURL);
			document.head.appendChild(customScript);

			let dataLayerScript = document.createElement('script');
			dataLayerScript.innerHTML = clientConfig.analytics.customanalytics.dataLayer;
			document.head.appendChild(dataLayerScript);
			// window.digitalData = clientConfig.analytics.customanalytics.dataLayer;
		}

		this.setTitle();
	}
}
</script>